export const gridDebug = (() => {
	const makeGrid = () => {
		let grid_ctn = document.createElement("div");
		grid_ctn.setAttribute("id", "grid-debug");
		grid_ctn.classList.add("grid-debug");

		let grid_wrapper = document.createElement("div");
		grid_wrapper.classList.add("wrapper");

		let grid_row = document.createElement("div");
		grid_row.classList.add("columns");

		let grid_items = [];

		for (let i = 0; i < 12; i++) {
			let item = document.createElement("div");
			item.classList.add("column");
			item.classList.add("is-1");

			let item_content = document.createElement("div");

			item.appendChild(item_content);

			grid_items.push(item);
		}

		grid_items.forEach((item) => grid_row.appendChild(item));
		grid_wrapper.appendChild(grid_row);
		grid_ctn.appendChild(grid_wrapper);

		document.body.insertAdjacentElement("beforeend", grid_ctn);
	};

	const createDebugSwitch = () => {
		let toggle_debug_ctn = document.createElement("div");
		toggle_debug_ctn.classList.add("debug-toggle");

		let checkbox_label = document.createElement("label");
		checkbox_label.setAttribute("for", "toggle_debug");
		checkbox_label.setAttribute("title", "Show grid");

		let checkbox = document.createElement("input");
		checkbox.setAttribute("type", "checkbox");
		checkbox.setAttribute("id", "toggle_debug");

		toggle_debug_ctn.appendChild(checkbox);
		toggle_debug_ctn.appendChild(checkbox_label);

		document.body.insertAdjacentElement("beforeend", toggle_debug_ctn);
	};

	const init = () => {
		createDebugSwitch();

		let checkbox = document.getElementById("toggle_debug");

		checkbox.addEventListener("change", (e) => {
			if (e.target.checked) {
				makeGrid();
			} else {
				let grid = document.getElementById("grid-debug");
				if (grid) {
					grid.remove();
				}
			}
		});
	};

	return {
		init: init,
	};
})();
